// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-treeview',
    // #endregion
    // #region Properties
    props: {
        keyMember: {
            type: String,
            required: false,
            default: 'categoryID'
        },
        dataSource: {
            type: Array,
            required: false,
            default: []
        },
        dataStructure: {
            type: String,
            required: false,
            default: 'tree',
            validValues: ['plain', 'tree'],
            validator(value) {
                if (!value.length) {
                    return true;
                }
                return ['tree', 'plain'].includes(value);
            }
        }
    },
    // #endregion
    // #region computed
    computed: {
        nodes() {
            if (this.dataStructure === 'tree') {
                return this.dataSource;
            }
            else {
                return this.dataSource.filter((item) => {
                    return item.parentID === '$';
                });
            }
        }
    },
    // #endregion
    // #region Methods
    methods: {
        hasChildren(node) {
            if (!utils.isNullOrEmpty(node?.childMode)) {
                return true;
            }
            if (this.dataStructure === 'tree') {
                return node.children && node.children.length > 0;
            }
            else {
                let tResult = this.dataSource.some(e => {
                    return e.parentID === node[this.keyMember];
                });
                return tResult;
            }
        },
        getChildren(node) {
            if (this.dataStructure === 'tree') {
                return node.children;
            }
            else {
                return this.dataSource.filter(e => {
                    return e.parentID === node[this.keyMember];
                });
            }
        },
    }
    // #endregion
});
// #endregion
